import React, { useState, useEffect } from "react";
import AddressModal from "./address_modal";
import Translations from "../../services/translation.service";
import ContactEdit from "../../assets/img/ContactEditPen.svg";
import IconEdit from "../../assets/img/iconEdit.svg";
const subscriptions = [];
const OcrField = (props) => {
  const { valid, value, validations, valueTranslation } = { ...props.data };
  const translatedValueDesc = props.translatedValueDesc
    ? props.translatedValueDesc
    : "";
  const placeholderValueDesc = props.placeholderValueDesc ? props.placeholderValueDesc : ""
  const requiredTranslation = props.requiredTranslation
    ? props.requiredTranslation
    : "";
  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [editContact, setEditContact] = useState(false);
  useEffect(() => {
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );
    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  const addressModal = () => {
    setOpenAddressModal((openAddressModal) => !openAddressModal);
  };

  const contactEditButton = () => {
    setEditContact((editContact) => !editContact);
  };

  const updateContactData = (value) => {
    props.updateContactData(value);
  };
  let fieldContent = null;
  if (props.data.key === "full_address") {
    if (props.hasAddressValues) {
      fieldContent = (
        <div>
          <div className="ocr-field-stf-lbl">
            {translatedValueDesc}
            {validations.required ? (
              <span>{" (" + requiredTranslation + ")"}</span>
            ) : null}
          </div>
          <div className={`ocr-field-stf ${props.validAddress ? "ocr-field-stf-valid" : "ocr-field-stf-invalid"}`}>
            <span className="ocr-view-address" onClick={addressModal}>
              {props.validAddress
                ? translationKeys["kw_ocr_view_detail"]
                : translationKeys["kw_edit_details"]}
            </span>
            {/* {props.validAddress ? (
              <>
                <span className="ocr-success">{translatedValueDesc}</span>
              </>
            ) : (
              <span className="ocr-failure">{translatedValueDesc}</span>
            )} */}
            {openAddressModal ? (
              <AddressModal
                open={addressModal}
                data={props.mappedByAddress}
                setArea={props?.setArea}
                governorateAreasList={props?.governorateAreasList}
                valid={props.validAddress}
                submitAddressData={props.submitAddressData}
              />
            ) : null}
          </div>
        </div>
      );
    } else {
      // Address - Initial Field
      fieldContent = (
        <div>
          <div className="ocr-field-stf-lbl">
            {translatedValueDesc}
            {validations.required ? (
              <span>{" (" + requiredTranslation + ")"}</span>
            ) : null}
          </div>
          <div className="ocr-field-stf">
            {placeholderValueDesc}
            {/* {validations.required ? (
              <span>{" (" + requiredTranslation + ")"}</span>
            ) : null} */}
          </div>
        </div>
      );
    }
  } else if (props.data.key === "311") {
    let inputClassNames = value
      ? !valid
        ? "filled invalid"
        : "filled"
      : !valid
        ? "invalid"
        : "";
    fieldContent =
      value || props?.hasAddressValues ? (
        <div>
          <div className="ocr-field-stf-lbl">
            {translatedValueDesc +
              " (" +
              translationKeys["kw_ocr_field_optional"] +
              ")"}
          </div>
          <div className={`ocr-field-stf ${editContact ? "ocr-field-stf-contact-invalid" : "ocr-field-stf-valid"}`} >
            {!editContact && value ? (
              <div>
                <div onClick={contactEditButton}>
                  <span className="ocr-input">
                    {valueTranslation ? valueTranslation : value}
                  </span>
                  {!valid &&
                    <span
                      className={
                        valid
                          ? value
                            ? "ocr-success"
                            : ""
                          : value
                            ? "ocr-failure"
                            : ""
                      }
                    >
                      {translatedValueDesc}
                    </span>
                  }
                  <img
                    src={ContactEdit}
                    className="contact-edit-icon"
                    alt="edit-icon"
                  />
                </div>
              </div>
            ) : !value && !editContact ? (
              <div onClick={contactEditButton}>
                {placeholderValueDesc
                  // +
                  // " (" +
                  // translationKeys["stf_kw_ocr_field_optional"] +
                  // ")"
                }
                <img
                  src={ContactEdit}
                  className="contact-edit-icon"
                  alt="edit-icon"
                />
              </div>
            ) : null}
            {editContact ? (
              <div>
                <input
                  value={value ? value : ""}
                  className={"form-contact-txt " + inputClassNames}
                  onChange={(e) => updateContactData(e.target.value)}
                  autoFocus="autofocus"
                  onBlur={contactEditButton}
                />
                <img
                  src={IconEdit}
                  className="contact-submit-icon"
                  onClick={contactEditButton}
                  alt="done-icon"
                />
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        // Contact - Initial State
        <div>
          <div className="ocr-field-stf-lbl">
            {translatedValueDesc +
              " (" +
              translationKeys["stf_kw_ocr_field_optional"] +
              ")"}
          </div>
          <div className="ocr-field-stf">
            {placeholderValueDesc
              // +
              // " (" +
              // translationKeys["stf_kw_ocr_field_optional"] +
              // ")"
            }
          </div>
        </div>
      );
  } else {
    fieldContent = valid ? (
      <div>
        <div className="ocr-field-stf-lbl">
          {translatedValueDesc}
          {validations.required ? (
            <span>{" (" + requiredTranslation + ")"}</span>
          ) : null}
        </div>
        <div className={`ocr-field-stf ${validations.required ? "ocr-field-stf-valid" : "ocr-field-stf-invalid"}`}>
          {value !== "" ?
            <span className="ocr-input">
              {valueTranslation ? valueTranslation : value}
            </span> : null}

          {/* {validations.required ? (
            <>
              <span className="ocr-success">
                {translatedValueDesc}
              </span>
            </>
          ) :
            <div>
              {translatedValueDesc}
              <span>{" (" + translationKeys["kw_ocr_field_optional"] + ")"}</span>
            </div>
          } */}
        </div>
      </div>
    ) : value !== "" ? (
      <div>
        <div className="ocr-field-stf-lbl">
          {translatedValueDesc}
        </div>
        <div className="ocr-field-stf ocr-field-stf-invalid">
          <span className="ocr-input">
            {valueTranslation ? valueTranslation : value}
          </span>
        </div>
      </div>
    ) : (
      // Other Fields - Initial State
      <div>
        <div className="ocr-field-stf-lbl">
          {translatedValueDesc}
          {validations.required ? (
            <span>{" (" + requiredTranslation + ")"}</span>
          ) : null}
        </div>
        <div className="ocr-field-stf">
          {props.data.key === "35" ?
            props?.ocrType === "kw_id" ? placeholderValueDesc :
              translationKeys["kw_ocr_placeholder_gcc_id"]
            : placeholderValueDesc}
          {/* {placeholderValueDesc} */}
          {/* {validations.required ? (
            <span>{" (" + requiredTranslation + ")"}</span>
          ) : null} */}
        </div>
      </div>
    );
  }

  return fieldContent;
};

export default OcrField;
